import { determineBrandFromURL, BRANDS } from "../helpers/brand";
import { observer } from "../animations/animate";

export const blog = async () => {
  const blogContainer = document.querySelector("[js-blog-container]");
  const loadMoreBtn = document.querySelector("[js-load-blog-stories]");
  let page = 2;

  const brand = determineBrandFromURL();
  const language = document
    .querySelector("html")
    ?.getAttribute("lang")
    ?.toLowerCase();

  if (!blogContainer || !loadMoreBtn) {
    return;
  }

  loadMoreBtn.addEventListener("click", () => {
    loadMoreArticles(page);
    page++;
  });

  const loadMoreArticles = async (page: number) => {
    const modelId = loadMoreBtn.getAttribute("js-id");
    const url = `/umbraco/api/blog/getposts?blogid=${modelId}&page=${page}&lang=${language}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.length < 6) {
        loadMoreBtn.classList.add("hidden");
      }

      generateBlogList(data);

      return data;
    } catch (err) {
      /* Error */
      console.log(err);
      return;
    }
  };

  const generateBlogList = (data) => {
    data.forEach((article) => {
      /* Main wrapper div */
      const newElmWrapper = document.createElement("div");
      newElmWrapper.classList.add("transition--max-height", "overflow--hidden");

      /* Container which animates */
      const newElmAnimator = document.createElement("div");
      newElmAnimator.setAttribute("js-animate", "fade-in");
      newElmWrapper.append(newElmAnimator);

      /* link tag for image */
      const newElmHref = document.createElement("a");
      newElmHref.setAttribute("href", article.url);
      newElmHref.setAttribute("aria-label", "go to blog article");
      newElmHref.classList.add(
        "display--b",
        "img-placeholder",
        "border--round",
        "aspect-ratio--0_75-1",
        "w--100"
      );
      newElmAnimator.append(newElmHref);

      /* Picture tag for image */
      const newElmPicture = document.createElement("picture");
      newElmPicture.classList.add("flex", "h--100");
      newElmHref.append(newElmPicture);

      /* Source tablet */
      const newElmSrcTablet = document.createElement("source");
      newElmSrcTablet.setAttribute("media", "(min-width: 48em)");
      newElmSrcTablet.setAttribute(
        "srcset",
        article.genericImageVideo.headerImgTablet
      );
      newElmPicture.append(newElmSrcTablet);

      /* Source Mobile */
      const newElmSrcMobile = document.createElement("source");
      newElmSrcMobile.setAttribute("media", "(min-width: 0)");
      newElmSrcMobile.setAttribute(
        "srcset",
        article.genericImageVideo.headerImgMobile
      );
      newElmPicture.append(newElmSrcMobile);

      /* Img */
      const newElmSrcImg = document.createElement("img");
      newElmSrcImg.setAttribute(
        "src",
        article.genericImageVideo.headerImgTablet
      );
      newElmSrcImg.setAttribute("alt", article.title);
      newElmSrcImg.setAttribute("loading", "lazy");
      newElmSrcImg.classList.add("img-cover", "border--round");
      newElmPicture.append(newElmSrcImg);

      /* Container for text content */
      const newElmTextContent = document.createElement("div");
      newElmTextContent.classList.add(
        "flex",
        "align-items--center",
        "flex-wrap",
        "gap--blog-categories",
        "margin--nav-links"
      );
      newElmAnimator.append(newElmTextContent);

      /* Category */
      const newElmCategory = document.createElement("p");
      newElmCategory.classList.add("t-tags-small");
      newElmCategory.textContent = article.blogCategories[0];
      newElmTextContent.append(newElmCategory);

      /* Location */
      const newElmLocation = document.createElement("p");
      newElmLocation.classList.add("t-tags-small");
      newElmTextContent.append(newElmLocation);

      /* Region */
      const newElmRegion = document.createElement("span");
      newElmRegion.classList.add("t-tags-small");
      newElmRegion.textContent = article.blogRegions[0] + ", ";
      newElmLocation.append(newElmRegion);

      /* Country */
      const newElmCountry = document.createElement("span");
      newElmCountry.classList.add("t-tags-small");
      newElmCountry.textContent = article.blogCountries[0];
      newElmLocation.append(newElmCountry);

      /* Title */
      const newElmTitle = document.createElement("a");
      newElmTitle.setAttribute("href", article.url);
      newElmTitle.setAttribute("aria-label", "go to blog article");
      newElmTitle.classList.add(
        brand === BRANDS.WILDE ? "t-h4" : "t-h3",
        "display--b",
        "margin--blog-listing-title",
        "cta",
        "cta--lg"
      );
      newElmTitle.textContent = article.title;
      newElmAnimator.append(newElmTitle);

      /* Preview container */
      const newElmPreviewWrapper = document.createElement("div");
      newElmPreviewWrapper.classList.add(
        brand === BRANDS.WILDE ? "only--mobile-1024" : "opacity--7"
      );
      newElmAnimator.append(newElmPreviewWrapper);

      /* Preview text */
      const newElmPreviewText = document.createElement("p");
      newElmPreviewText.classList.add(
        "t-copy-tiny",
        "line-clamp",
        "line-clamp--3",
        "margin--blog-listing-content",
        "rich-text-blog-listing"
      );
      newElmPreviewText.textContent = article.articlePreview;
      newElmPreviewWrapper.append(newElmPreviewText);

      /* Append new article into main blog articles list */
      blogContainer.append(newElmWrapper);

      /* Apply animation effect to new article preview */
      observer.observe(newElmAnimator);
    });
  };
};
